import { useQuery, UseQueryResult } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

export interface UseTriggerEvaluationCountFilter {
  datasetId?: string;
  triggerId?: string;
}

export function getQueryKey(filter: UseTriggerEvaluationCountFilter) {
  return ["triggerEvaluationCount", filter];
}

export function useTriggerEvaluationCount(
  filter: UseTriggerEvaluationCountFilter,
  resourceOwnerId?: string,
): UseQueryResult<number, Error> {
  const { triggerService } = useDomainServices();
  const { datasetId, triggerId } = filter;

  return useQuery({
    queryKey: getQueryKey(filter),
    queryFn: async ({ signal }) => {
      if (datasetId !== undefined) {
        return triggerService.getTriggerEvaluationCountForDataset(datasetId, {
          abortSignal: signal,
          resourceOwnerId,
        });
      }

      if (triggerId !== undefined) {
        return triggerService.getTriggerEvaluationCountForTrigger(triggerId, {
          abortSignal: signal,
          resourceOwnerId,
        });
      }

      return 0;
    },
    enabled: datasetId !== undefined || triggerId !== undefined,
    placeholderData: (previousData) => previousData,
  });
}
